import React from 'react';
import axios from 'axios';
import { enqueueSnackbar } from 'notistack';
import RequestDetails from '../../components/common/RequestDetails';
import { IoIosCloseCircleOutline } from "react-icons/io";
import { hostNameBack } from '../../utils/constants';
import { FaEye } from 'react-icons/fa';
import Dropdown from '../../components/common/Dropdown';

function Tradelead() {
    const [buyerRequests, setBuyerRequests] = React.useState([]);
    const [showDetailsModel, setShowDetailsModel] = React.useState(null);
    const [showMakeOfferModel, setShowMakeOfferModel] = React.useState(null);
    const [sellerOffers, setSellerOffers] = React.useState([]);
    const [filterType, setFilterType] = React.useState('Products');

    const fetchBuyerRequests = async () => {
        const token = localStorage.getItem("token");
        try {
            const response = await axios.get(`${hostNameBack}/api/v1/tradeleads/requests/all`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setBuyerRequests(response.data.requests);
        } catch (e) {
            enqueueSnackbar(e.response?.data?.error || "Something went wrong!", { variant: "error" });
        }
    };

    const fetchSellerOffers = async () => {
        const token = localStorage.getItem("token");
        try {
            const response = await axios.get(`${hostNameBack}/api/v1/tradeleads/myOffers`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setSellerOffers(response.data.offers);
        } catch (e) {
            enqueueSnackbar(e.response?.data?.error || "Something went wrong!", { variant: "error" });
        }
    };

    React.useEffect(() => {
        fetchBuyerRequests();
        fetchSellerOffers();
    }, []);

    const handleMakeOfferClick = (request) => {
        const existingOffer = sellerOffers.find(offer => offer.requestId === request._id);
        if (existingOffer) {
            setShowMakeOfferModel({ ...request, offer: existingOffer });
        } else {
            setShowMakeOfferModel(request);
        }
    };

    const filteredRequests = buyerRequests.filter((request) => {
        return filterType === "Products"
            ? request.requestFor === "product"
            : request.requestFor === "service";
    });

    const requestElems = filteredRequests.length > 0 ? filteredRequests.map((request, index) => {
        const existingOffer = sellerOffers.find(offer => offer.requestId === request._id);
        return (
            <div key={index}>
                <div className="row">
                    <div className="field titleField"><p className='title'>{request.title}</p></div>
                    <p className="field requestForField">{request.requestFor.charAt(0).toUpperCase() + request.requestFor.substring(1)}</p>
                    <p className="field priceField">${request.budget}</p>
                    {request.requestFor === "service" && <p className="field durationField">{request.duration} days</p>}
                    {request.requestFor === "product" && <p className="field quantityField">{request.quantity}</p>}
                    <p className="field postedAtField">{new Date(request.createdAt).toLocaleDateString()}</p>
                    <div className="field actionsField">
                        <button className="secondaryBtn" onClick={() => handleMakeOfferClick(request)}>
                            {existingOffer ? "Edit Offer" : "Make Offer"}
                        </button>
                        <FaEye className='icon' style={{ width: "18px", height: "18px" }} onClick={() => setShowDetailsModel(request)} />
                    </div>
                </div>
                {(filteredRequests.length > 1 && filteredRequests.length - 1 !== index) && <div className="horizontalLine"></div>}
            </div>
        );
    }) : <div className="row">Nothing to show here...</div>;

    return (
        <div className='tradeleadDiv tableDiv'>
            <section className="section">
                <div className="tradeleadContent tableContent">
                    <div className="upper">
                        <h2 className="secondaryHeading">Buyer <span>Requests</span></h2>
                        <div className="upperRight">
                            <Dropdown options={["Products", "Services"]} onSelect={setFilterType} selected={filterType} />
                        </div>
                    </div>
                    <div className="header">
                        <p className='title'>Request</p>
                        <p>Request For</p>
                        <p>Budget</p>
                        <p>{filterType === "Products" ? "Quantity" : "Duration"}</p>
                        <p>Posted At</p>
                        <p>Actions</p>
                    </div>
                    <div className="tradeleadRows rows">{requestElems}</div>
                </div>
            </section>
            {showDetailsModel && <RequestDetails showDetailsModel={showDetailsModel} setShowDetailsModel={setShowDetailsModel} />}
            {showMakeOfferModel && <MakeOfferModel showMakeOfferModel={showMakeOfferModel} setShowMakeOfferModel={setShowMakeOfferModel} fetchSellerOffers={fetchSellerOffers} />}
        </div>
    );
}

export default Tradelead;




function MakeOfferModel({ showMakeOfferModel, setShowMakeOfferModel, fetchSellerOffers }) {
    const { _id: requestId, offer } = showMakeOfferModel || {};
    const [formData, setFormData] = React.useState({
        coverLetter: "",
        price: '',
        duration: 1,
        quantity: 1
    });
    const token = localStorage.getItem("token");

    React.useEffect(() => {
        if (offer)
            setFormData(offer);
    }, [showMakeOfferModel, offer]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (formData.price < 5) {
            enqueueSnackbar("Budget can't be less than $5", { variant: "warning" })
            return
        }
        else if (formData.quantity < 1 && showMakeOfferModel.requestFor === "product") {
            enqueueSnackbar("Quantity can't be less than 1", { variant: "warning" })
            return
        }
        else if (formData.duration < 1 && showMakeOfferModel.requestFor === "service") {
            enqueueSnackbar("Duration can't be less than 1", { variant: "warning" })
            return
        }

        const url = offer
            ? `${hostNameBack}/api/v1/tradeleads/offer/${requestId}/${offer._id}`
            : `${hostNameBack}/api/v1/tradeleads/offer/${requestId}`;
        const method = offer ? 'put' : 'post';
        await axios[method](url, formData, { headers: { Authorization: `Bearer ${token}` } })
            .then(response => {
                enqueueSnackbar(response.data.message, { variant: 'success' });
                setShowMakeOfferModel(null);
                fetchSellerOffers();
            })
            .catch(error => {
                enqueueSnackbar(error.response.data.error || "Something went wrong!", { variant: 'error' });
            });
    };

    const handleWithdrawOffer = async () => {
        await axios.delete(`${hostNameBack}/api/v1/tradeleads/offer/${requestId}/${offer._id}`, { headers: { Authorization: `Bearer ${token}` } })
            .then(response => {
                enqueueSnackbar(response.data.message, { variant: 'success' });
                setShowMakeOfferModel(null);
                fetchSellerOffers();
            })
            .catch(error => {
                enqueueSnackbar(error.response.data.error || "Something went wrong!", { variant: 'error' });
            });
    };

    return (
        <div className='makeOfferModelDiv popupDiv'>
            <div className="makeOfferModelContent popupContent">
                <form className="form" onSubmit={handleFormSubmit}>
                    <h2 className="secondaryHeading"><span>{offer ? "Edit" : "Make"}</span> Offer</h2>
                    <div className="horizontalLine"></div>
                    <div className="inputDiv">
                        <label>Description</label>
                        <textarea className='inputField' name='coverLetter' placeholder='Enter your offer details' value={formData.coverLetter} onChange={handleInputChange} required />
                    </div>
                    <div className="inputDiv">
                        <label>Price (US$)</label>
                        <input type='Number' className='inputField' name='price' placeholder='Enter your price offer' value={formData.price} onChange={handleInputChange} required />
                    </div>
                    {showMakeOfferModel.requestFor === "service" && <div className="inputDiv">
                        <label>Duration (in days)</label>
                        <input type='Number' className='inputField' name='duration' placeholder='Enter Duration' value={formData.duration} onChange={handleInputChange} required />
                    </div>}
                    {showMakeOfferModel.requestFor === "product" && <div className="inputDiv">
                        <label>Quantity</label>
                        <input type='Number' className='inputField' name='quantity' placeholder='Enter Quantity' value={formData.quantity} onChange={handleInputChange} required />
                    </div>}
                    <div className="buttonsDiv">
                        <button type='submit' className='primaryBtn'>{offer ? 'Update' : 'Send'}</button>
                        {offer && <button type='button' className='dangerBtn' onClick={handleWithdrawOffer}>Withdraw Offer</button>}
                        <button className='secondaryBtn' onClick={() => setShowMakeOfferModel(null)}>Close</button>
                    </div>
                </form>
            </div>
            <div className="popupCloseBtn">
                <IoIosCloseCircleOutline className='icon' onClick={() => setShowMakeOfferModel(null)} />
            </div>
        </div>
    );
}